import { COUNTRIES, DEFAULT_COUNTRY } from '@moda/portal-stanchions';
import { UseCookiesQuery_cookies as Cookies } from '../../generated/types/UseCookiesQuery';
import { decode as decodePreferences } from '../../hooks/usePreferences/tools';

export const getSearchApiHeaders = (cookies: Cookies) => {
  const { cloudfrontViewerCountry } = cookies;
  const preferences = decodePreferences(cookies.preferences);
  const preferencesCountry =
    COUNTRIES.find(country => country.id === preferences.countryId) || DEFAULT_COUNTRY;

  return {
    'client-country-code':
      cloudfrontViewerCountry && cloudfrontViewerCountry !== 'US'
        ? cloudfrontViewerCountry
        : preferencesCountry.alpha2Code,
    'ab-tests': ['restrict-designers-to-us', 'no-trunkshow-on-new'].join(',')
  };
};
